import { put, select } from 'redux-saga/effects';
import { PRODUCTS_COMPARE_MANAGE, PRODUCTS_COMPARE_LOAD_DATA } from '../../actions';

import { getUserLastActionData } from '../../selectors';
import { UnifiedCompareState } from '../../types';
import { SagaParams, removeGroupFromState } from './utils';
import { createListSaga } from './create-list-saga';
import { updateListSaga } from './update-list-saga';
import { deleteListSaga } from './delete-list-saga';

/**
 * NOTE: Обрабатывает удаление списка сравнения с сервера
 */
export function* handleDeleteListFromServer(params: SagaParams): Generator {
  yield* deleteListSaga(params);
}

/**
 * NOTE: Обрабатывает локальное удаление списка сравнения из состояния
 */
export function* handleDeleteListFromState(
  params: SagaParams,
  currentState: UnifiedCompareState,
): Generator {
  const updatedState = removeGroupFromState(currentState, params.groupId);
  yield put(PRODUCTS_COMPARE_MANAGE.success(updatedState));
}

/**
 * NOTE: Обрабатывает создание нового списка сравнения
 */
export function* handleListCreation(params: SagaParams, groupName: string, productIds: string[]): Generator {
  const listForAPI = {
    name: groupName,
    groupId: params.groupId,
    products: productIds,
  };

  yield* createListSaga({ ...params, list: listForAPI });
}

/**
 * NOTE: Обрабатывает обновление существующего списка сравнения
 */
export function* handleListUpdate(params: SagaParams, groupName: string, productIds: string[]): Generator {
  const listForAPI = {
    name: groupName,
    groupId: params.groupId,
    products: productIds,
  };

  yield* updateListSaga({ ...params, list: listForAPI });
}

/**
 * NOTE: Загружает данные продуктов для отображения
 */
export function* loadProductsData(productIds: string[]): Generator {
  const userLastActionData = yield select(getUserLastActionData);
  yield put(
    PRODUCTS_COMPARE_LOAD_DATA.request({
      groupId: userLastActionData.groupId,
      productIds,
    }),
  );
}
